import React, { useEffect, useCallback } from 'react';
import './ImageLightbox.css';

const ImageLightbox = ({ images, currentIndex, onClose, onNavigate }) => {
  const current = images[currentIndex];
  const hasPrev = currentIndex > 0;
  const hasNext = currentIndex < images.length - 1;

  const goPrev = useCallback(() => {
    if (hasPrev) onNavigate(currentIndex - 1);
  }, [hasPrev, currentIndex, onNavigate]);

  const goNext = useCallback(() => {
    if (hasNext) onNavigate(currentIndex + 1);
  }, [hasNext, currentIndex, onNavigate]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') goPrev();
      if (e.key === 'ArrowRight') goNext();
    };
    document.addEventListener('keydown', handleKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose, goPrev, goNext]);

  if (!current) return null;

  return (
    <div
      className="image-lightbox-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={`Visor de fotos: ${current.name}`}
    >
      <div className="image-lightbox-toolbar" onClick={(e) => e.stopPropagation()}>
        <span className="image-lightbox-title" title={current.name}>
          {current.name}
        </span>
        <span className="image-lightbox-counter">
          {currentIndex + 1} / {images.length}
        </span>
        <button
          type="button"
          className="image-lightbox-close"
          onClick={onClose}
          title="Cerrar (Esc)"
          aria-label="Cerrar visor"
        >
          ×
        </button>
      </div>

      {hasPrev && (
        <button
          type="button"
          className="image-lightbox-nav image-lightbox-nav-prev"
          onClick={(e) => {
            e.stopPropagation();
            goPrev();
          }}
          title="Anterior"
          aria-label="Foto anterior"
        >
          ‹
        </button>
      )}

      <div className="image-lightbox-stage" onClick={(e) => e.stopPropagation()}>
        <img
          key={current.url}
          src={current.url}
          alt={current.name}
          className="image-lightbox-img"
          draggable={false}
        />
      </div>

      {hasNext && (
        <button
          type="button"
          className="image-lightbox-nav image-lightbox-nav-next"
          onClick={(e) => {
            e.stopPropagation();
            goNext();
          }}
          title="Siguiente"
          aria-label="Foto siguiente"
        >
          ›
        </button>
      )}
    </div>
  );
};

export default ImageLightbox;
